import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';

import { Observable } from 'rxjs';

import { AppConstants } from '../../app.constants';
import { ImagePerDayApi } from './models/image-per-day-api';
import { ServerChangesApi } from './models/server-change-api';

@Injectable({
    providedIn: 'root'
})
export class WorkloadsMiscApiService {
    private readonly resourceUrl = '/hist/workloads/images';

    constructor(private http: HttpClient) {
    }

    getImagesPerDay(days: number): Observable<ImagePerDayApi[]> {
        const url = `${AppConstants.Configuration.apiUrlHist}${this.resourceUrl}/perday?days=${days}`;

        return this.http.get<ImagePerDayApi[]>(url);
    }

    getServerChanges(days: number): Observable<ServerChangesApi> {
        const url = `${AppConstants.Configuration.apiUrlHist}${this.resourceUrl}/serverchanges?days=${days}`;

        return this.http.get<ServerChangesApi>(url);
    }
}
